import { useQuery } from 'react-query';

import { useRequest } from '@frontend/api';
import type { QueryFunction } from '@frontend/api/src/common/queryFunction';

import type {
  ImportableItemDetailsData,
  ImportableItemDetailsQueryKey,
  UseImportableItemDetailsParams,
} from './types';
import { getImportableItemDetailsQueryKey } from './util';

export const useImportableItemDetails: QueryFunction<
  ImportableItemDetailsData,
  [UseImportableItemDetailsParams],
  ImportableItemDetailsQueryKey
> = (params, queryFunctionOptions = {}) => {
  const { requestOptions, queryOptions } = queryFunctionOptions;
  const request = useRequest(requestOptions);
  const queryKey = getImportableItemDetailsQueryKey(params);

  return useQuery<
    ImportableItemDetailsData,
    unknown,
    ImportableItemDetailsData,
    ImportableItemDetailsQueryKey
  >({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) => {
      return request(
        `/quotes/components/${params.componentId}/part_importer_preview`,
        {
          init: {
            method: 'GET',
            signal,
          },
        },
      );
    },
  });
};
